export var TO_RADIANS = Math.PI / 180;
export var TO_DEGREES = 180 / Math.PI;
